const adminSidebar = {
  namespaced: true,
  state: () => ({
    ActiveItem: "",
    ActiveMenu: "",
  }),
  getters: {
    getActiveItem(state) {
      return state.ActiveItem;
    },
    getActiveMenu(state) {
      return state.ActiveMenu;
    },
  },
  actions: {
    setActive({ commit }, menu) {
      commit("SET_MENU_ITEM", menu.activeMenuItem)
      commit("SET_MENU", menu.activeMenu)
    },
  },
  mutations: {
    SET_MENU_ITEM: (state, menuItem) => {
      state.ActiveItem = menuItem
    },
    SET_MENU: (state, menu) => {
      state.ActiveMenu = menu
    }
  }
}

export default adminSidebar;

